import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DialogModel } from '@shared/models/dialog.model';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { BehaviorSubject, Observable, Subject, zip } from 'rxjs';
import { QueryModel } from '@shared/models/query-model';
import { select, Store } from '@ngrx/store';
import { IVirtualGridCollectionState } from '@shared/store/reducers/virtual-grid.reducer';
import { TaskManagerState } from '../../../task-manager/store/task-manager.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TempAccessTokenService } from '@core/interceptors/auth.interceptor';
import { CommandService } from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DialogService } from '@shared/services/dialog-service';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { DataSurveyResponseFormViewComponent } from '../data-survey-response-form-view/data-survey-response-form-view.component';
import { skip, take, takeUntil } from 'rxjs/operators';
import { hasFeature } from '@shared/store/selectors/security.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { Configuration } from '@shared/models/configuration';
import { getDialogAttachment } from '../../../task-manager/store/task-manager.selector';
import {
  AcceptResponseCommand, CreateNewSurveyDataItemRowCommand,
  PrepareUserResponseCommand, RejectResponseCommand, SubmitResponseCommand,
  UpdateSurveyDataItemCommand
} from '../../commands/survey.commands';
import { SetTempAccessTokenAction } from '@shared/store/actions/auth.actions';
import { SetDialogAttachmentAction } from '../../../task-manager/store/task-manager.action';
import { DeleteQueryAction } from '@shared/store/actions/query.actions';
import { DeleteSmartGridDataStateAction } from '@shared/store/actions/smart-grid.actions';
import { EntityFields } from '../../../dac6-reporter/Fields';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { PageEvent } from '@angular/material/paginator';
import { DataSurveyService } from '../../services/data-survey.service';

@Component({
    standalone: false,
    selector: 'particle-data-survey-reviewer-respondent-container',
  templateUrl: './data-survey-reviewer-respondent-container.component.html',
  styleUrls: ['./data-survey-reviewer-respondent-container.component.scss']
})
export class DataSurveyReviewerRespondentContainerComponent implements OnInit, OnDestroy {

  data: DialogModel;
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  attachment: any;
  surveyExecutionId: string;
  public surveyId: string;
  public executionId: string;
  breadcrumbs: BreadcrumbModel[];
  hasTabs: boolean;
  public userId: string;
  isReview: boolean;
  unsubscibes$ = new Subject<void>();
  private response$: Observable<any>;
  responseId: string;
  private responseStatus: string;
  private response: any;
  executionSourceType: string;
  private breadcrumbQueryModel: QueryModel;
  private breadcrumbs$: Observable<any>;
  private submitAction: string;
  isEmpty = false;
  endpointName = 'DataSurveyApi';
  canAddNewRow: boolean;
  isGridConfigReady: boolean;
  private responseQueryModel: QueryModel;
  private sectionType: string;
  private sourceType: string;
  itemBreadcrumb: BreadcrumbModel;
  isItemFormView: boolean = false;
  formViewItemId: string;
  isDirty: boolean;
  surveyFormViewBreadcrumbKey = 'BreadcrumbByDataSurveyFormId';
  formViewOnInit = true;
  breadcrumbChildren: any;
  attachmentType: string;
  onBreadcrumbChange = new BehaviorSubject(true);
  private isVisitor: boolean;
  private taskTicketId: string;
  private taskBoardId: string;
  hasFlowCharts: boolean = false;
  flowchartId: any;
  constructor(private store: Store<IVirtualGridCollectionState>,
              private taskManagerStore: Store<TaskManagerState>,
              protected activatedRoute: ActivatedRoute,
              private location: Location,
              private tempAccessTokenService: TempAccessTokenService,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              public snackBarService: SnackBarService,
              private dialogService: DialogService,
              public router: Router,
              private securityStore: Store<SecurityState>,
              public queryState: Store<IQueryState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private dataSurveyService: DataSurveyService
  ) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'DataSurvey',
        title: 'Data Survey',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      }
    ];
    this.hasTabs = false;
    this.invalidateSubject = new InvalidateSubject();
    this.canAddNewRow = false;
  }
  @ViewChild('surveyResponseForm', {static: true}) surveyResponseForm: DataSurveyResponseFormViewComponent;
  async canDeactivate() {
    let res = true;
    if ( this.isItemFormView && this.surveyResponseForm && this.surveyResponseForm.editedFields.length > 0 ) {
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.unsubscibes$)).subscribe(data => {
        if (data.action === 'OK') {
          this.surveyResponseForm.save();
          res = false;
        } else if (data.action === 'Closed') {
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }
  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.ticketId) {
      this.taskTicketId = this.activatedRoute.snapshot.queryParams.ticketId;
    }
    if (this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.boardId) {
      this.taskBoardId = this.activatedRoute.snapshot.queryParams.boardId;
    }

    const userFeatures$ = this.securityStore.pipe(select(hasFeature), takeUntil(this.unsubscibes$));
    const routingParams$ = this.activatedRoute.params;
    console.log('ngOnInit at Data Survey Response');
    zip(userFeatures$, routingParams$).subscribe((results: any[]) => {


      if (results && results[0] && results[1]) {
        const userFeatures = results[0];
        const params = results[1];
        this.isVisitor = userFeatures('VISITOR') ? true : false;
        this.surveyExecutionId = params.executionId;
        this.userId = params.userId;
        if (this.userId === 'review' ) {
          this.handleSurveyReviewer(params);

        } else {
          this.openTaskAttachment();
        }
      }
    });
    this.queryState.pipe(select(getQueryResponse, 'BreadcrumbByDataSurveyFormId'), skip(1), takeUntil(this.unsubscibes$)).subscribe((item: any) => {
      if (item && item.breadcrumb.length > 0) {
        this.breadcrumbChildren = item.breadcrumb;
        if (!this.itemBreadcrumb) {
          this.itemBreadcrumb = this.getBreadcrumb(item.breadcrumb[0]);
        }
        if (this.formViewOnInit && this.hasFormView( this.attachmentType )) {
          this.formViewOnInit = false;
          this.setDefaultFormViewInInit(this.breadcrumbChildren[0].id);
        }
      }
    });

  }

  private handleSurveyReviewer(params) {
    this.isReview = true;
    this.responseQueryModel = QueryProvider.getQuery('ResponseById');
    this.response$ = this.queryState.pipe(select(getQueryResponse, 'ResponseById'));
    this.response$.pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
      console.log('This is a response', item);
      if (item && item.code) {
        this.response = item;
        this.responseId = this.response.id;
        this.surveyId = this.response.surveyId;
        this.hasFlowCharts = this.response.hasFlowCharts;
        console.log('Response', item);
        this.breadcrumbQueryModel = QueryProvider.getQuery('BreadcrumbByResponseId');
        this.executionId = item.executionId;
        if (item.userExecutionId) {
          this.executionId = item.userExecutionId;
        }
        this.surveyExecutionId = this.executionId;

        this.getFlowchartList( this.surveyExecutionId);

        this.executionSourceType = this.response.executionSourceType;
        this.sectionType = this.response.sectionType;
        this.sourceKey = 'DataSurveyResponseShare';
        this.setGridConfiguration();

        this.breadcrumbs$ = this.queryState.pipe(select(getQueryResponse, 'BreadcrumbByResponseId'));
        this.breadcrumbs$.pipe(takeUntil(this.unsubscibes$)).subscribe(state => {
          if (state) {
            this.breadcrumbs = state.breadcrumb;
            if (this.hasFormView(this.sectionType)) {
              QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByDataSurveyFormId', {
                '[ID]'                  : this.executionId,
                '[EXECUTION_SOURCETYPE]': this.executionSourceType
              });
              this.formViewOnInit = false;
            }

          }
        });
        QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByResponseId', {'[ID]': item.id});

      }
    });
    QueryProvider.invokeQuery(this.queryState, 'ResponseById', {'[ResponseId]': this.surveyExecutionId});
  }

  private setGridConfiguration() {
    let config = Configuration.getSmartGridConfig(this.sourceKey);
    config = {...config};
    config.Parameters['EXECUTION_ID'] = this.surveyExecutionId;
    config.Parameters['EXECUTION_SOURCE_TYPE'] = this.executionSourceType;
    config.SourceType = this.executionSourceType;
    Configuration.setSmartGridConfig(this.executionSourceType, config);
    this.isGridConfigReady = true;
    this.invalidateSubject.invalidate();
  }

  private openTaskAttachment() {
    this.taskManagerStore.pipe(select(getDialogAttachment))
      .pipe(take(1)).subscribe(attachmentInfo => {
      if (attachmentInfo && attachmentInfo.attachment) {
        this.attachment = attachmentInfo.attachment;
        this.setAttachmentType(this.attachment);
        this.hasTabs = this.attachment.MetaData && this.attachment.MetaData.FieldSectionCount > 1;
        this.surveyExecutionId = this.attachment.MetaData.ExecutionId;

        this.getFlowchartList( this.surveyExecutionId);

        this.executionSourceType = this.attachment.MetaData.ExecutionSourceType;
        this.sourceType = this.attachment.MetaData.SourceType;
        this.canAddNewRow = this.attachment.MetaData.CanAddNewRow;
        this.executionId = this.surveyExecutionId;
        this.surveyId = this.attachment.MetaData.SurveyId;
        this.hasFlowCharts = this.attachment.MetaData.HasFlowCharts;
        this.flowchartId = this.attachment.MetaData.FlowchartId;
        this.breadcrumbs = [
          <BreadcrumbModel>{
            id: 'DataSurvey',
            title: 'Data Survey',
            type: 'DataSurvey',
            relativeUrl: 'data-survey',
            isDisabled : this.isVisitor
          }
        ];
        if (this.attachment.MetaData.SurveyDisplayId) {
          this.breadcrumbs.push(<BreadcrumbModel>{
            id: 'survey',
            title: this.attachment.MetaData.SurveyDisplayId,
            type: 'survey',
            relativeUrl: `data-survey/${this.attachment.MetaData.SurveyId}`,
            isDisabled : this.isVisitor
          });
        }
        this.breadcrumbs.push(<BreadcrumbModel>{
          id: 'attachment',
          title: this.attachment.AttachmentTitle,
          type: 'Attachment',
          relativeUrl: this.attachment.Url
        });
        if (!this.userId && this.hasFormView(this.attachmentType)) {
          QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByDataSurveyFormId', {'[ID]': this.executionId, '[EXECUTION_SOURCETYPE]': this.executionSourceType});
        }
        if (this.userId) {
          this.commandService.executeCommand(new PrepareUserResponseCommand(this.surveyId, this.surveyExecutionId, this.attachment))
            .pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
            if (commandState && commandState.Payload) {
              this.executionId = commandState.Payload.UserExecutionId;
              this.responseId = commandState.Payload.Id;
              this.responseStatus = commandState.Payload.Status;
              this.sourceKey = 'UserDataSurveyResponseShare';
              this.submitAction = 'SubmitUserResponse';
              if (this.hasFormView(this.attachmentType)) {
                QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByDataSurveyFormId', {'[ID]': this.executionId, '[EXECUTION_SOURCETYPE]': this.executionSourceType});
              }
              this.setGridConfiguration();
            }
          });
        } else {
          this.sourceKey = 'DataSurveyResponseShare';
          this.submitAction = 'SubmitResponse';
          this.responseId = this.attachment.MetaData.ResponseId;
          this.setGridConfiguration();
        }
      } else {
        this.isEmpty = true;
      }
    });
  }

  getAttachmentSourceType(): string {
    const splitIndex = this.attachment.AttachmentTitle.indexOf('-');
    const attachmentSourceType = (splitIndex !== -1 ||
      splitIndex !== this.attachment.AttachmentTitle.length - 1) ?
      this.attachment.AttachmentTitle.slice(splitIndex + 1, this.attachment.AttachmentTitle.length) : '';
    return attachmentSourceType;
  }
  setAttachmentType(attachment) {
    const splitIndex = attachment.AttachmentTitle.indexOf('-');
    this.attachmentType = (splitIndex !== -1 ||
      splitIndex !== attachment.AttachmentTitle.length - 1) ?
      attachment.AttachmentTitle.slice(splitIndex + 1, attachment.AttachmentTitle.length) : '';
  }
  ngOnDestroy(): void {
    console.log('ngOnDestroy at Data Survey Response');
    this.tempAccessTokenService.resetAccessToken();
    this.taskManagerStore.dispatch(new SetTempAccessTokenAction(null));
    this.taskManagerStore.dispatch(new SetDialogAttachmentAction(null));
    if (this.breadcrumbQueryModel && this.breadcrumbQueryModel.key) {
      this.queryState.dispatch(new DeleteQueryAction(this.breadcrumbQueryModel, null, null));
    }
    if (this.responseQueryModel && this.responseQueryModel.key) {
      this.queryState.dispatch(new DeleteQueryAction(this.responseQueryModel, null, null));
    }
    this.queryState.dispatch(new DeleteSmartGridDataStateAction(this.executionSourceType));
    this.unsubscibes$.next();
    this.unsubscibes$.complete();
  }
  onValueChange($event) {
    console.log($event);
    if ($event.fieldDefinition && $event.fieldDefinition.identityField && $event.fieldDefinition.cellViewer === 'HyperlinkCellViewerComponent') {
      this.setDefaultFormViewInInit($event.item.id);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog($event.item, $event.fieldDefinition, '500px', '500px').subscribe();
      return;
    }
    if ($event.action && $event.action.id) {
      switch ($event.action.id) {
        case 'Edit':
          this.openEditor($event);
          break;
      }
    }
  }

  private setNewRecordFormView(id: string, title: string) {
    this.formViewItemId = null;
    setTimeout(()=>{
      this.itemBreadcrumb = new BreadcrumbModel();
      this.itemBreadcrumb.relativeUrl = this.breadcrumbs[this.breadcrumbs.length - 1].relativeUrl;
      this.itemBreadcrumb.id = id;
      this.itemBreadcrumb.title = title;

      if (this.isItemFormView) {
        this.breadcrumbs.pop();
      }
      const hasFormView = this.hasFormView(this.attachmentType);
      if (hasFormView) {
        this.itemBreadcrumb.type = 'DropDown';
        this.breadcrumbChildren.unshift( this.getBreadcrumb(this.itemBreadcrumb) );
        this.itemBreadcrumb.children = this.breadcrumbChildren;
      }

      this.breadcrumbs.push(this.itemBreadcrumb);
      this.isItemFormView = true;
      this.formViewItemId = id;
    }, 0)
  }

  private formatBreadcrumbDropdown(id: string) {
    const selectedItemBreadCrumbIndex = this.breadcrumbChildren.findIndex(item => item.id === id);
    const selectedItemBreadCrumb = this.breadcrumbChildren[selectedItemBreadCrumbIndex];
    this.breadcrumbChildren.splice(selectedItemBreadCrumbIndex, 1);
    this.breadcrumbChildren.unshift(selectedItemBreadCrumb);
  }
  setDefaultFormViewInInit(breadcrumbId) {
    const foundBreadcrumb = this.breadcrumbChildren.find(item => item.id === breadcrumbId);
    this.itemBreadcrumb = this.getBreadcrumb(foundBreadcrumb);
    this.breadcrumbs.push(this.itemBreadcrumb);
    this.formatBreadcrumbDropdown(breadcrumbId);
    this.breadcrumbs[this.breadcrumbs.length - 1].children = this.breadcrumbChildren;
    this.isItemFormView  = true;
    this.formViewItemId = breadcrumbId;
  }

  public openEditor(event: any) {
    if (event.fieldDefinition.key === EntityFields.AssociateEnterprises) {
      const sourceConfigKey = event.fieldDefinition.configKey;
      const config = Configuration.getSmartGridConfig(sourceConfigKey);
      config.Parameters['ID'] = event.item.id;
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '800px', '1500px', this.sectionType)
      .subscribe(state => {
        if (state.action === 'OK') {
          console.log('After Edit', state);
          const item = {id: event.item.id, fieldValues: {}, executionId: this.executionId};
          const value = event.item.cells[event.fieldDefinition.key].value;
          item.fieldValues[event.fieldDefinition.key] = value;
          const command = new UpdateSurveyDataItemCommand(item, this.surveyId, this.surveyExecutionId, this.executionSourceType, this.userId);
          this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
            console.log('Command State', commandState);
            this.invalidateSubject.invalidate();
          });
        }
      });
  }

  navigateToPreviousRoute() {
    this.location.back();
  }

  showGridView() {

  }
  toggleItemsView(event) {

    if (event.checked && this.breadcrumbChildren && this.breadcrumbChildren.length > 0) {
      this.setDefaultFormViewInInit(this.itemBreadcrumb.id);
    } else {
      this.triggerGridViewFromFormView();
    }
  }

  showBoardView() {

  }

  acceptResponse() {
    this.dialogService.showTextAreaInputDialog('Approve Changes', '', 'Comment')
      .pipe(takeUntil(this.unsubscibes$))
      .subscribe(state => {
        if (state.action === 'OK') {
          console.log('Accept comment', state);
          const command = new AcceptResponseCommand(this.response.id, state.data.input.text);
          this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$))
            .subscribe(commandStae => {
              this.snackBarService.showInformation(`You have accepted the response successfully`);
              const url = `data-survey/${this.response.surveyId}/${this.response.executionId}`;
              this.router.navigateByUrl(url);
            });
        }
      });
  }

  rejectResponse() {
    this.dialogService.showTextAreaInputDialog('Reject Response', '', 'Comment')
      .pipe(takeUntil(this.unsubscibes$))
      .subscribe(state => {
        if (state.action === 'OK') {
          console.log('Reject comment', state);
          const command = new RejectResponseCommand(this.response.id, state.data.input.text);
          this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$))
            .subscribe(commandStae => {
              this.snackBarService.showInformation(`You have rejected the response successfully`);
              this.location.back();
            });
        }
      });
  }

  submitResponse() {
    const dialogModel: DialogModel = DialogModel.create(
      'Submit Changes',
      'SubmitResponseComponent', {'status': this.responseStatus, 'description': '' },
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe(res => {
      console.log('here are the inputs', res);
      if (res.action === 'OK') {
        const command = new SubmitResponseCommand(this.submitAction, this.surveyId, this.surveyExecutionId,
          this.executionId, res.data.input.status, this.responseId, res.data.input.description);
        this.commandService.executeCommand(command).subscribe(commandState => {
          if (commandState) {
            this.responseStatus = commandState.Payload.Status;
            this.snackBarService.showInformation(`Response submitted succefully`);
            if (this.isVisitor) {
              this.router.navigate([`task-manager/team/card/${this.taskBoardId}/${this.taskTicketId}`]);
            } else {
              this.location.back();
            }
          }
        });
      }
    });
  }

  navigateToTaskManager() {
    this.router.navigateByUrl('task-manager/card');
  }

  addNewRecord() {
    const command = new CreateNewSurveyDataItemRowCommand(this.surveyId, this.responseId, this.surveyExecutionId, this.sourceType, this.executionSourceType, this.userId);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$))
      .subscribe(commandState => {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showInformation(`New record added`);
        this.invalidateSubject.invalidate();
        this.setNewRecordFormView(commandState.Payload.Item.Id, commandState.Payload.Title);
      });
  }
  public rowCallback = (context: RowClassArgs) => {
    if (!context || !context.dataItem) {
      return '';
    }
    if (!context.dataItem.cells['SourceItemId'] ||
      !context.dataItem.cells['SourceItemId'].value ||
      !context.dataItem.cells['SourceItemId'].value.length) {
      return 'new-row';
    }
    return context.dataItem.isEdited ? 'edited-row' : '';
  }


  onFieldSectionChanged($event: any) {
    this.hasTabs = $event.length > 1;
  }

  breadcrumbChanged($event: BreadcrumbModel) {
    console.log('breadcrumbChanged', $event);
    if (this.itemBreadcrumb && $event.id !== this.itemBreadcrumb.id) {
      this.isItemFormView = false;
      this.formViewItemId = null;
      this.breadcrumbs.splice(this.breadcrumbs.length - 1, 1);
    }
  }
  onDropDownSelection(event) {
    this.formViewItemId = null;
    setTimeout(() =>
    {
      this.formViewItemId = event.id;

      this.breadcrumbs.pop();
      this.itemBreadcrumb = this.getBreadcrumb(event);

      this.breadcrumbs.push(this.itemBreadcrumb);
      this.formatBreadcrumbDropdown(this.itemBreadcrumb.id);
      this.breadcrumbs[this.breadcrumbs.length - 1].children = this.breadcrumbChildren;
    }, 0);

  }
  onPageChange(event: PageEvent) {

    this.formViewItemId = null;

    setTimeout(() =>
    {


      this.formViewItemId = this.breadcrumbs[this.breadcrumbs.length - 1].children[event.pageIndex].id;
      this.itemBreadcrumb = this.getBreadcrumb(this.breadcrumbs[this.breadcrumbs.length - 1].children[event.pageIndex]);
      this.breadcrumbs.pop();


      this.breadcrumbs.push(this.itemBreadcrumb);
      this.formatBreadcrumbDropdown(this.itemBreadcrumb.id);
      this.breadcrumbs[this.breadcrumbs.length - 1].children = this.breadcrumbChildren;
    }, 0);
  }
  save() {

  }
  onFormSaveChange(event) {
    if (this.hasFormView(this.attachmentType)) {
      QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByDataSurveyFormId', {
        '[ID]': this.executionId,
        '[EXECUTION_SOURCETYPE]': this.executionSourceType
      });
    }
  }

  private triggerGridViewFromFormView() {
    this.isItemFormView = false;
    this.breadcrumbs.pop();
    if (this.hasFormView(this.attachmentType)) {
      QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByDataSurveyFormId', {
        '[ID]': this.executionId,
        '[EXECUTION_SOURCETYPE]': this.executionSourceType
      });
    }
  }
  hasFormView(attachmentSourceType) {
    return (attachmentSourceType.includes('Pre-Arrangement') || // === 'Pre-Arrangements' ||
      attachmentSourceType.includes('Arrangement')); // === 'Arrangement');
  }
  getBreadcrumb(breadcrumb) {
    const newItemBreadcrumb = new BreadcrumbModel();
    newItemBreadcrumb.relativeUrl = breadcrumb.relativeUrl;
    newItemBreadcrumb.id = breadcrumb.id;
    newItemBreadcrumb.title = breadcrumb.title;
    if (breadcrumb.type) {
      newItemBreadcrumb.type = breadcrumb.type;
    }
    return newItemBreadcrumb;
  }
    flowchartList:any[] = [];
   selectedTabIndex: any;
  async getFlowchartList(executionId:string) {
   await this.dataSurveyService.getFlowchartsByExecutionId(executionId).pipe(takeUntil(this.unsubscibes$)).subscribe(x=>{
     this.flowchartList = x.items;
    });


  }
  onTabIndexChange(event) {

    this.selectedTabIndex = event;
    this.isGridConfigReady = false;

    setTimeout(() =>
    {
      this.executionSourceType = this.flowchartList[this.selectedTabIndex].cells.executionSourceType.value
      this.setGridConfiguration();
    }, 0);

  }

}
